import * as React from 'react';

import { enumQuoteStatus } from '@rematter/frontend-lib-api-client';
import { ContentCard } from '@rematter/ui-web';

import { QuoteDetailRecord, QuoteFormState } from '../../types/quote';

import { QuoteFormFooterActions } from './QuoteFormFooterActions';
import { QuoteInfoForm } from './QuoteInfoForm';

type Props = {
  quote?: QuoteDetailRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: QuoteFormState) => void;
  isSaving?: boolean;
};

export const QuoteTabOverview: React.FC<Props> = ({
  quote,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => {
  const canEdit =
    quote?.status === enumQuoteStatus.Draft ||
    quote?.status === enumQuoteStatus.Sent;

  return (
    <div className="@QuoteTabOverview flex max-h-full flex-col gap-5 p-5">
      <ContentCard className="p-0 pt-5">
        <QuoteInfoForm mode="edit" disabled={!canEdit} />
        {canEdit && (
          <QuoteFormFooterActions
            onSaveUpdates={onSaveUpdates}
            onDiscard={onDiscard}
            isSaving={isSaving}
          />
        )}
      </ContentCard>
    </div>
  );
};
